import React from 'react';
import { useTranslation } from 'react-i18next';
import { down } from 'static/icons/resizable';
import * as S from './BackLink.styles';

export type BackLinkProps = {
  isOnPageWithTabs?: boolean;
  action?: () => void | null;
};

export const BackLink = ({ isOnPageWithTabs, action }: BackLinkProps) => {
  const { t } = useTranslation();

  const goBack = () => {
    action && action();
  };

  return (
    <S.BackLinkWrapper
      onClick={goBack}
      isOnPageWithTabs={isOnPageWithTabs}
      data-testid='button-go-back'
    >
      <S.BackLinkIcon src={down} />
      <S.BackLinkText kind='body'>{t('other.goBack')}</S.BackLinkText>
    </S.BackLinkWrapper>
  );
};
